// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1208":"34a3f116","2475":"d34fa3c2","3129":"887ac97b","3344":"286d40f3","3452":"8e78614b","4871":"17922459","8291":"b12458b7"}[chunkId] + ".chunk.css";
};